interface BarItem {
  label: string
  value: number
}

interface MiniBarChartProps {
  data: BarItem[]
  color?: string
  emptyLabel?: string
}

function MiniBarChart({ data, color = '#1E4FBF', emptyLabel = 'Sem dados suficientes.' }: MiniBarChartProps) {
  const max = Math.max(1, ...data.map(d => d.value))
  const semDados = data.every(d => d.value === 0)

  if (data.length === 0 || semDados) {
    return (
      <div className="h-[170px] sm:h-[200px] flex items-center justify-center">
        <p className="text-[13px] text-[#9CA3AF]">{emptyLabel}</p>
      </div>
    )
  }

  return (
    <div className="flex items-end gap-1.5 sm:gap-3 h-[170px] sm:h-[200px] w-full">
      {data.map((item, idx) => {
        const heightPct = Math.max(4, Math.round((item.value / max) * 100))
        return (
          <div key={idx} className="group flex-1 flex flex-col items-center gap-1.5 sm:gap-2 h-full justify-end min-w-0">
            <span className="text-[10.5px] sm:text-[11px] font-semibold text-[#12141A] tabular-nums">{item.value}</span>
            <div className="w-full max-w-[32px] rounded-t-[6px] bg-[#F1F2F4] flex items-end overflow-hidden" style={{ height: '100%' }}>
              <div
                className="w-full rounded-t-[6px] transition-all duration-500 ease-out group-hover:opacity-80"
                style={{ height: `${heightPct}%`, backgroundColor: color }}
              />
            </div>
            <span className="text-[9.5px] sm:text-[10.5px] text-[#9CA3AF] truncate w-full text-center font-medium" title={item.label}>{item.label}</span>
          </div>
        )
      })}
    </div>
  )
}

export default MiniBarChart
